import axios from 'axios'
import AbstractAxiosMock from './AbstractAxiosMock'
import { config } from '@/config'

export default class DieciWebshopServiceMock extends AbstractAxiosMock {
  'GET /cartdata/getBasketSummary' () {
    if (config.MOCK_FULLBASKET) {
      return axios.get(config.MOCK_BASKET_URL)
    } else {
      return axios.get(config.MOCK_BASKET_EMPTY_URL)
    }
  }

  async 'POST /storedata/pointindeliveryareapolygons' (method, url, { zip }) {
    zip = parseInt(zip)
    if (zip === 9999) {
      return axios.get(config.MOCK_SEARCHZIP_EMPTY_URL)
    } else if (zip === 8000) {
      return axios.get(config.MOCK_SEARCHZIP_URL)
    } else if (zip === 0) {
      return axios.get(config.MOCK_SEARCHZIP_URL)
    } else if (zip === 8001) {
      const result = await axios.get(config.MOCK_SEARCHZIP_URL)
      result.data.itemlist.splice(1, 5)
      return result
    } else {
      const result = await axios.get(config.MOCK_SEARCHZIP_URL)
      result.data.itemlist.splice(2, 5)
      return result
    }
  }

  async 'GET /customerdata/listOrderPublic' (method, url) {
    const result = await axios.get(config.MOCK_LOGGEDIN ? config.MOCK_LASTORDER_URL: config.MOCK_LASTORDER_EMPTY_URL)
    // HACK: we fix what we think is wrong with the result data
    result.data.formData.forEach(v => {
      v.url = v.url.indexOf('selectStorePublic') >= 0
        ? config.WEBSHOP_ENDPOINT + '/customerdata/selectOrder'
        : v.url
    })
    return result
  }

  async 'POST /customerdata/selectOrder' (method, url, data) {
    const result = await axios.get(config.MOCK_SELECTORDER_URL)
    return result
  }
}
